
import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl, Validator, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[Cifnif][ngModel]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: CifnifDirective,
    multi:true
  }]
})
export class CifnifDirective implements Validator{

  constructor() { }

  validate(c: AbstractControl): { [key: string]: any; } {
    let doc="";
    doc=c.value;
    
    
    
    let errorcif=this.isValidCif(doc);
    if(errorcif==null){
      return null;
    }

    let errornif=this.isValidNif(doc);
    if(errornif==null){
      return null;
    } 

    let errornie=null;
    if(doc){
      errornie=this.validateNIE(doc);
      if(errornie==null){
        return null;
      }
    }
    

    return {"cifnotvalid": errorcif, "nifnotvalid": errornif, "nienotvalid": errornie};
  }

  

  isValidCif(abc){
    if(!abc){
      abc="";
    }
    var par = 0;
    var non = 0;
    var letras = "ABCDEFGHJNPQRSUVW";
    var letr = abc.charAt(0);
    
    
   
    if (abc.length<9) {
      //alert('El Cif debe tener 9 dÃ­gitos');
      return "El CIF debe tener 9 dígitos";
    }
   
    if (letras.indexOf(letr.toUpperCase())==-1) {
      //alert("El comienzo del Cif no es vÃ¡lido");
      return "El comienzo del CIF no es válido";
    }
   
    for (var zz=2;zz<8;zz+=2) {
      par = par+parseInt(abc.charAt(zz));
    }
   
    for (zz=1;zz<9;zz+=2) {
      var nn = 2*parseInt(abc.charAt(zz));
      if (nn > 9) nn = 1+(nn-10);
      non = non+nn;
    }
   
    var parcial = par + non;
    var control = (10 - ( parcial % 10));
    if (control==10) control=0;
   
    let letrasControl=["J","A","B","C","D","E","F","G","H","I"];
    if (control!=abc.charAt(8)) {
      if(letr!="A" || letr!="B" || letr!="E" || letr!="H"){
        if(abc.charAt(8)==letrasControl[control]){
          return null;
        }
        
      }
      //alert("El Cif no es vÃ¡lido");
      return "El cif no es válido";
    }
    //alert("El Cif es vÃ¡lido");
    return null;
  }
   
   
  isValidNif(abc){
    if(!abc){
      abc="";
    }
    var dni=abc.substring(0,abc.length-1);
    var letr=abc.charAt(abc.length-1);
    if(abc.length!=9){
      return "El NIF debe tener 8 dígitos y una letra"
    }
    if (!isNaN(letr)) {
      //alert('Falta la letra');
      return "Falta la letra del NIF";
    }else{
      var cadena = "TRWAGMYFPDXBNJZSQVHLCKET";
      var posicion = dni % 23;
      var letra = cadena.substring(posicion,posicion+1);
      if (letra!=letr.toUpperCase()){
        //alert("Nif no vÃ¡lido");
        return "Nif no válido";
      }
    }
    //alert("Nif vÃ¡lido")
    return null;
  }

  validateNIE(dni) {
    var numero, letr, letra;
    var expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

    
    dni = dni.toUpperCase();

    if(expresion_regular_dni.test(dni) === true){
        numero = dni.substr(0,dni.length-1);
        numero = numero.replace('X', 0);
        numero = numero.replace('Y', 1);
        numero = numero.replace('Z', 2);
        letr = dni.substr(dni.length-1, 1);
        numero = numero % 23;
        letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
        letra = letra.substring(numero, numero+1);
        if (letra != letr) {
            //alert('Dni erroneo, la letra del NIF no se corresponde');
            return "NIE erroneo, la letra del NIF no se corresponde.";
        }else{
            //alert('Dni correcto');
            return null;
        }
    }else{
        //alert('Dni erroneo, formato no válido');
        return "NIE erróneo, formato no válido.";
    }
  }

  

}



// WEBPACK FOOTER //
// ./src/app/directives/cifnif.directive.ts